import { z } from 'zod';

const clientSecretSchema = z.string().max(255, 'Client Secret cannot be longer than 255 characters');
const clientSecretRequiredSchema = clientSecretSchema.min(1, 'Please provide a client secret');

// Edit
export const editIdentityProviderBaseFormSchema = z.object({
  clientID: z.string().min(1, 'Please provide a client ID').max(255, 'Client ID cannot be longer than 255 characters'),
  issuerURL: z
    .string()
    .min(1, 'Please provide an issuer URL')
    .max(255, 'Issuer URL cannot be longer than 255 characters')
    .startsWith('https://', 'Must start with "https://"')
    .min(9, 'Please provide an issuer URL'),
  clientSecret: clientSecretSchema,
});
export type EditIdentityProviderBaseFormData = z.infer<typeof editIdentityProviderBaseFormSchema>;

// Add
export const addIdentityProviderBaseFormSchema = editIdentityProviderBaseFormSchema.extend({
  // When adding a new identity provider, a client secret must be provided
  clientSecret: clientSecretRequiredSchema,
});
export type AddIdentityProviderBaseFormData = z.infer<typeof addIdentityProviderBaseFormSchema>;
